export default "__VITE_ASSET__Cr82855R__$_?url__"